import { createContext, useContext, useState, useEffect } from 'react';
import { EnvConfig } from '../types/EnvConfig';
import { loadConfig } from '../utils/configLoader';
import { ILandingOrigen } from '../types/LandingOrigen';
import { useOrigenStore } from '../Services/Providers/origenStore';
import { obtenerOrigen } from '../Services/API/obtenerOrigen';

interface ConfigContextProps {
  config: EnvConfig;
  origen: ILandingOrigen | undefined;
  isLoading: boolean;
}

const getPaisFromDominio = (): "AR" | "UY" | "BR" => {
  if (process.env.REACT_APP_DEV_MODE == "true") {
    const pais: '"AR" | "UY" | "BR"' = process.env.REACT_APP_PAIS as '"AR" | "UY" | "BR"';
    return pais.toUpperCase() as any;
  }
  const hostname = window.location.hostname;

  if (hostname.endsWith(".com.ar")) return "AR";
  if (hostname.endsWith(".com.uy")) return "UY";
  if (hostname.endsWith(".com.br")) return "BR";

  return "AR";
};

/** /gestion y /retomar toman la marca de `GET /origenes/v1/actual` del BFF: no le piden nada al monolito. */
const RUTAS_SIN_MONOLITO = ['/gestion', '/retomar'];
const esRutaSinMonolito = (pathname: string = window.location.pathname): boolean => {
  const base = (process.env.REACT_APP_BASENAME || '/').trim().replace(/\/$/, '');
  return RUTAS_SIN_MONOLITO.some((ruta) => pathname === `${base}${ruta}` || pathname.startsWith(`${base}${ruta}/`));
};

const initialConfig: EnvConfig = {
  endpoint: "",
  local_hostname: "",
  pais: getPaisFromDominio(),
  public_url: "",
  url_emision: "",
  url_prefix: "",
  anio_gracias: 30,
  prefix: "",
  recaptcha_key: "",
  version: ""
}

const ConfigContext = createContext<ConfigContextProps>({
  config: initialConfig,
  origen: undefined,
  isLoading: true
});


export const ConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [config, setConfig] = useState<EnvConfig>(initialConfig);
  const { setOrigen, origenData } = useOrigenStore();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadConfig().then((cfg) => {
      setConfig({
        ...cfg,
        pais: getPaisFromDominio(),
      } as EnvConfig);
    });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!origenData.ready && !esRutaSinMonolito()) {
        const parametros = await obtenerOrigen();
        setOrigen({
          ...origenData,
          ...parametros,
        });
      }
      setIsLoading(false);
    }
    //setTimeout( () => {
    fetchData()
    //}, 2000)
  }, [])

  return (
    <ConfigContext.Provider
      value={{ config, origen: origenData, isLoading }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = (): ConfigContextProps => {
  return useContext(ConfigContext);
};
